var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaglogo3DHks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 566.93 173.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2,.cls-3{fill:#1d1d1b;}.cls-3{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 86.27,
    cy: 64.15,
    fx: 86.27,
    fy: 64.15,
    r: 57.45,
    gradientTransform: "translate(.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e3f0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#beddb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#99ca90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#7fc381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#24aa4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a13a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m566.93,33.21c-13.31-12.24-31.82-18.22-52.72-18.22-41.49,0-71.72,27.25-71.72,69.92s30.23,69.93,71.72,69.93c19.52,0,35.45-3.76,52.72-12.78v-69.55h-44.01v27.07h16.55v21.62c-5.45,3.01-12.49,6.58-25.25,6.58-24.97,0-41.3-18.04-41.3-42.86s16.34-42.86,41.3-42.86c14.11,0,23.45,5.26,31.12,12.76l21.6-21.6h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m329.38,18.18h-32.6l-24.19,71.07c-3.9,11.65-5.54,18.16-7.59,26.65h-.2c-2.46-9.28-5.13-17.57-7.59-24.88l-24.4-72.85h-34.44l46.95,133.26h37.31l46.75-133.26h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m447.54,151.44l-48.59-133.26h-36.29l-46.74,133.26h31.78l8.4-24.68h47.77l8.61,24.68h35.06Zm-51.67-48.96h-31.98l9.02-25.07c2.87-8.1,5.12-16.39,6.56-23.69h.41c1.44,7.9,3.69,14.61,6.36,22.11l9.64,26.65h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.71,89.52c-4.98,5.46-8.65,11.89-10.73,19.22-.36,1.28-1.7,1.26-2.03-.02C1.27,102.24.14,95.1.01,88.11-.83,40.28,37.21.84,84.97.01c23.91-.41,45.71,8.92,61.64,24.35,7.17,6.65,11.63,16.04,11.82,26.59.36,20.55-15.98,37.49-36.5,37.85-10.15.17-19.43-3.74-26.25-10.24l-7.4,7.82c8.89,8.24,20.84,13.18,33.9,12.96,7.38-.13,14.36-1.89,20.57-4.94-2.7,28.76-26.36,50.16-55.22,50.66-16,.27-30.63-5.94-41.35-16.21-1.39-1.39-2.57-3.63-2.61-5.84-.08-4.44,3.46-8.11,7.89-8.19,1.89-.03,3.65.74,5.01,1.79l8.95-9.25c-3.7-3.25-8.56-5.18-13.86-5.09-11.32.19-20.33,9.54-20.13,20.87.1,5.61,2.41,10.64,6.11,14.28,12.98,12.45,30.82,20.17,50.19,19.83,38.96-.67,69.98-32.85,69.29-71.87l.28-1.97c4.97-5.46,8.74-12.02,10.84-19.29.36-1.27,1.69-1.26,2.03.02,1.77,6.68,2.67,13.78,2.8,20.97.84,47.84-37.19,87.28-84.96,88.1-23.89.42-45.69-8.91-61.62-24.33-7.18-6.65-11.61-16.12-11.8-26.67-.36-20.55,15.98-37.49,36.5-37.85,10.15-.17,19.43,3.75,26.25,10.24l7.4-7.82c-8.89-8.24-20.84-13.18-33.9-12.96-7.38.12-14.33,1.91-20.55,4.96,2.7-28.75,26.3-50.14,55.16-50.63,16.13-.28,30.85,6.03,41.6,16.44,1.41,1.41,2.37,3.36,2.41,5.55.08,4.44-3.46,8.11-7.9,8.19-1.85.03-3.62-.59-5.02-1.62l-8.94,9.1c3.7,3.25,8.56,5.18,13.86,5.08,11.32-.19,20.33-9.54,20.13-20.87-.1-5.61-2.42-10.65-6.12-14.29-13-12.63-30.69-20.12-50.23-19.78C46.3,16.66,15.27,48.82,15.96,87.84l-.25,1.68h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaglogo3DHks);
export default __webpack_public_path__ + "static/media/VAG LOGO 3D_HKS.e61f088977611154491ce33097f78e16.svg";
export { ForwardRef as ReactComponent };